// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Textarea from "react-textarea-autosize";
import { ContentState } from "draft-js";
import ReactHtmlParser from "react-html-parser";

// Components Imports
import CustomRevvEditor from "../CustomRevvEditor";

// Action Imports
import { EditorActions } from "../../actions";
import { updateDocumentClickedComponentID } from "../../actions/DocumentActions/index";
import { updateToolpaneView } from "../../actions/ToolbarActions/toolbarActions";

// Internal Imports
import { getDraftData } from "../../utils/documentUtils";
import { getComponentEditorData } from "../../utils/components";
import { DOCUMENTS } from "../../constants";

// Destructuring
const { nukeEditorState } = EditorActions;
const { COMPONENT_FEATURE } = DOCUMENTS;
const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

class CustomTableText extends Component {
  _handleBlur = (cellData, change) => {
    // console.debug(cellData, change);
    const { mode } = this.props;
    const cellValue = {
      data: cellData.data,
    };

    if (COMPONENT_FEATURE[mode].allowDiff) {
      cellValue.currentContent = cellData.currentContent;
    }

    if ("highlightedHtml" in cellData)
      cellValue.highlightedHtml = cellData.highlightedHtml;
    this.props.updateCellData(cellValue, change);
    // this.props.updateDocumentClickedComponentID(null, true, null);
  };

  _getEditorData = () => {
    const { mode, cellData: value } = this.props;
    let cellData = {};
    let data;
    if (typeof value === "number") {
      data = ContentState.createFromText(value.toString());
    } else if (value instanceof Object) {
      cellData = getDraftData(value, mode);
    } else if (typeof value === "string") {
      data = ContentState.createFromText(value);
      cellData = {
        data,
        currentContent: data,
      };
    } else {
      cellData = value;
    }

    if (cellData === {}) {
      cellData.data = data;
      if (COMPONENT_FEATURE[mode].allowDiff) cellData.currentContent = data;
    }

    return cellData;
  };

  render() {
    const { editable, section } = this.props;
    // 1. Edit mode table
    if (editable || section.type === DOCUMENT_COMPONENT_TYPES.TABLE) {
      const {
        mode,
        value,
        templateType,
        componentMeta,
        removeHighlightSelection,
        updateHoveredSectionId,
        isTableCellActive,
        handleDropdownsOnBlur,
        handleColorPicker,
      } = this.props;
      const cellData = this._getEditorData(value);

      if (cellData !== null) {
        const updatedSection = {
          ...section,
          ...cellData,
          componentMeta,
        };
        return (
          <CustomRevvEditor
            section={updatedSection}
            mode={mode}
            handleBlur={this._handleBlur}
            templateType={templateType}
            componentMeta={this.props.componentMeta}
            removeHighlightSelection={removeHighlightSelection}
            isCustomTableTextEditor
            isDocCustomTextEditor={false}
            isComponentActive={isTableCellActive}
            updateHoveredSectionId={updateHoveredSectionId}
            updateDocumentClickedComponentID={
              this.props.updateDocumentClickedComponentID
            }
            isSeparateToolbar
            customToolbarRef={this.props.customToolbarRef}
            readOnly={section.lock || this.props.isLocked}
            handleDropdownsOnBlur={handleDropdownsOnBlur}
            handleColorPicker={handleColorPicker}
          />
        );
      }

      return null;
    }

    // 2. View mode table
    const { value } = this.props;
    let inputType;
    if (typeof value === "string" || typeof value === "number") {
      inputType = (
        <Textarea
          value={value}
          disabled={!editable}
          className={`auto-size-textarea ${
            editable ? "" : "textarea-disabled"
          }`}
        />
      );
    }

    if (value instanceof Object && value.html) {
      const { showDocumentDiffView } = this.props;
      let htmlRenderView = value.html;
      if (showDocumentDiffView) {
        htmlRenderView = value.diffHtml || value.html;
      }
      inputType = (
        <div>
          {value.highlightedHtml
            ? ReactHtmlParser(value.highlightedHtml)
            : ReactHtmlParser(htmlRenderView)}
        </div>
      );
    }

    return <div>{inputType}</div>;
  }
}

const mapStateToProps = (state, props) => {
  const { cellID, componentMeta } = props;
  const {
    components,
    clickedActiveComponentId,
    clickedActiveComponentType,
    preventClickedComponentIdUpdate,
  } = state.DocumentStore;
  let isTableCellActive = false;
  if (clickedActiveComponentId === cellID) isTableCellActive = true;

  const cellData = getComponentEditorData(components, componentMeta);

  return {
    cellData,
    isTableCellActive,
    clickedActiveComponentType,
    preventClickedComponentIdUpdate,
  };
};

const mapDispatchToProps = {
  updateDocumentClickedComponentID,
  updateToolpaneView,
  nukeEditorState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomTableText);



// WEBPACK FOOTER //
// ./src/components/RevvTable/CustomTableText.js